import { gql } from "@apollo/client";

export const GET_PRESIGN_URL = gql`
  query PreSignedUrl($name: String!, $contentType: String) {
    preSignedUrl(name: $name, contentType: $contentType) {
      url
    }
}
`;